export default [
    { selector: null,                      text: 'Willkommen bei DisplayDeck! Eine kurze Tour zeigt dir die ersten Schritte.' },
    { selector: '[data-tour="screens"]',   text: 'Hier verbindest du dein erstes Display unter „Displays".' },
    { selector: '[data-tour="playlists"]', text: 'Hier legst du Playlists für deine Inhalte an.' },
    { selector: '[data-tour="library"]',   text: 'Unter „Media" lädst du deine Inhalte hoch.' },
];
